/* eslint-disable no-unused-vars */
import Typography from "typography";
import fairyGatesTheme from "typography-theme-fairy-gates";

import theme from "./theme";

fairyGatesTheme.overrideStyles = ({ adjustFontSizeTo, rhythm }, options, styles) => ({
  a: {
    backgroundImage: "none",
    color: theme.main.colors.oceanDark,
    textShadow: "none"
  }
});

export default new Typography(fairyGatesTheme);



// WEBPACK FOOTER //
// ./src/styles/typography.js